import { render, staticRenderFns } from "./BaseDeviceView.vue?vue&type=template&id=51d7dd99&scoped=true&"
import script from "./BaseDeviceView.vue?vue&type=script&lang=js&"
export * from "./BaseDeviceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d7dd99",
  null
  
)

export default component.exports